module.exports = __webpack_public_path__ + "img/banner.e5642761.jpg";